import React from 'react';
import PropTypes from 'prop-types';
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  useLocation,
} from 'react-router-dom';

import {
  ENDPOINT_SECURITY,
  ENDPOINT_REQUEST_WORKSPACE,
  ENDPOINT_DUP_PDF,
  ENDPOINT_DUP_PDF_COMBO,
} from 'env-create-react-app';

import bannerContentsArray from './BannerContents';
import Header from './components/Header';
import Overview from './components/Overview';
import Content from './components/Content';
import Security from './components/Security';
import RequestWorkspace from './components/RequestWorkspace';
import dupPdf from './docs/AD-DAP_Data_Use_Agreement_2022.pdf';
import dupPdfCombo from './docs/AD-DAP_Data_Use_Agreement_and_Terms_and_Conditions_2022.pdf';

import {
  msalObj,
  signIn,
  signOut,
  handleRedirect,
} from './auth/signin';

class App extends React.Component {
  constructor(props) {
    super(props);

    // this.pathname = useLocation();

    // Register Callbacks for Redirect flow
    handleRedirect(); // handles any redirect (like request password change)

    // eslint-disable-next-line no-restricted-globals
    history.scrollRestoration = 'manual'; // prevent autoscroll on page reload. Can sometimes prevent banners from showing.

    let loggedIn = false;
    let name = '';
    if (msalObj.getAccount()) {
      loggedIn = true;
      const account = msalObj.getAccount();

      if (typeof account.idToken === 'undefined' || account.idToken == null) {
        console.error('Failed to obtain idToken');
        console.error(account);
      } else {
        const givenName = account.idToken.given_name;
        const familyName = account.idToken.family_name;
        name = `${givenName} ${familyName}`;
      }
    }

    this.state = { loggedIn, name };
  }

  appSignOut() {
    signOut();
    this.setState({ loggedIn: false });
  }

  render() {
    const { loggedIn, name } = this.state;

    return (
      <>
        <Header loggedIn={loggedIn} name={name} signIn={signIn} signOut={() => this.appSignOut()} />
        <div className="banner-container">
          {bannerContentsArray}
        </div>
        <div id="flex">
          <Router>
            <AppContentRouter loggedIn={loggedIn} />
          </Router>
        </div>
      </>
    );
  }
}

const AppContentRouter = ({ loggedIn }) => {
  const { pathname } = useLocation();

  return (
    <Switch>
      <Redirect from="/:url*(/+)" to={pathname.slice(0, -1)} />
      <Route exact path={ENDPOINT_SECURITY}>
        <Security />
      </Route>
      <Route exact path={ENDPOINT_REQUEST_WORKSPACE}>
        <RequestWorkspace loggedIn={loggedIn} signIn={signIn} />
      </Route>
      <Route exact path={ENDPOINT_DUP_PDF}>
        <div style={{ position: 'relative', width: '100%', height: 'calc(100vh - 4rem)' }}>
          <object data={dupPdf} type="application/pdf" width="100%" height="100%">
            <embed src={dupPdf} type="application/pdf" width="100%" height="100%" />
          </object>
        </div>
      </Route>
      <Route exact path={ENDPOINT_DUP_PDF_COMBO}>
        <div style={{ position: 'relative', width: '100%', height: 'calc(100vh - 4rem)' }}>
          <object data={dupPdfCombo} type="application/pdf" width="100%" height="100%">
            <embed src={dupPdfCombo} type="application/pdf" width="100%" height="100%" />
          </object>
        </div>
      </Route>
      <Route exact path="/">
        <Overview />
        <Content />
      </Route>
      <Redirect to="/" />
    </Switch>
  );
};

AppContentRouter.propTypes = {
  loggedIn: PropTypes.bool.isRequired,
};

export default App;
